import { LbaItemTag } from "@/components/SearchForTrainingsAndJobs/components/LbaItemTag"

export function LbaJobEngagementTag() {
  return (
    <LbaItemTag color="pink" iconClassName="fr-icon-accessibility-line">
      EMPLOYEUR HANDI-ENGAGÉ
    </LbaItemTag>
  )
}
